export default function validate(formProps) {
    const errors = {};

    if (!formProps.status) {
        errors.status =
            'Status is required! Please select a status for the redirect!';
    }

    if (formProps.status && formProps.status !== 410) {
        if (!formProps.redirect_to) {
            errors.redirect_to = 'Redirect To field is required!';
        } else if (
            formProps.redirect_to &&
            formProps.redirect_to.length < 5 &&
            formProps.redirect_to !== '/'
        ) {
            errors.redirect_to = 'Please enter a minimum of 5 characters!';
        }
    }

    if (!formProps.redirect_from) {
        errors.redirect_from = 'Redirect From field is required!';
    } else if (formProps.redirect_from && formProps.redirect_from.length < 5) {
        errors.redirect_from = 'Please enter a minimum of 5 characters!';
    }

    if (!formProps.site_id) {
        errors.site_id =
            'Website is required! Please select a website for the redirect!';
    }

    return errors;
}



// WEBPACK FOOTER //
// ./src/containers/redirects/forms/validation.js